import React from 'react'

export default function Agriculture() {
  return (
    <div>Agriculture</div>
  )
}
